import React from 'react'
import './Footerbanner.css'

const Footerbanner = () => {
  return (
    <div className='footerbanner'>

         <div className='container'>
                     <div className='meettxtbox'>
                     <h3>Partner with a Reliable & Experienced Studio</h3>
                     <p>Let's get in touch. The coffee is on us!</p>
                     </div>
                     <div id='contactdiv'> <button className='contactbtn'>Contact Us</button></div> 
        </div>
    </div>
  )
}

export default Footerbanner
